var PRIMARY = "rgba(61, 205, 88, 1.0)";
var PRIMARY_HOVER = "rgba(50,173,60, 1.0)";
var PRIMARY_SELECTED = "rgba(10, 154, 37, 1.0)";
var SECONDARY = "rgba(66, 180, 230, 1.0)";
var SECONDARY_LIGHT = "rgba(66, 180, 230, 0.7)";
var SECONDARY_LIGHT_HOVER = "rgba(66, 180, 230, 0.3)";
var SECONDARY_HOVER = "rgba(41, 155, 205, 1.0)";
var SECONDARY_SELECTED = "rgba(0, 122, 205, 1.0)";
var STANDARD = "rgba(98, 100, 105, 1.0)";
var STANDARD_HOVER = "rgba(73, 75, 80, 1.0)";
var STANDARD_LIGHT = "rgba(98, 100, 105, 1.0)";
var BORDER = "rgba(159, 160, 164, 1.0)";
var BORDER_HOVER = "rgba(98, 100, 105, 1.0)";
var GRAYBG = "rgb(250, 250, 250)";
var GRAY_LIGHT = "rgb(98,100,105,0.6)";
var GRAY_LIGHTBG = "rgb(98,100,105,0.4)";
var GRAY_NONE = "rgb(98,100,105,0)";
var DIVIDER = "rgba(230, 230, 230, 1.0)";
var ALTERNATIVE = "rgba(255, 255, 255, 1.0)";
var INFORMATION = "rgba(0, 122, 205, 1.0)";
var WARNING = "rgba(228, 127, 0, 1.0)";
var ERROR = "rgba(220, 10, 10, 1.0)";

///hexaString must be in the format "#012345" or "#012" with each value 0,1,2,3,4,5 that can be 0-9 or A-F
///opacity must me from 0.0 to 1.0 
//https://gist.github.com/danieliser/b4b24c9f772066bcf0a6
var fromHexaToRgba = function fromHexaToRgba(hexCode) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var hex = hexCode.replace('#', '');
  if (hex.length === 3) {
    hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
  }
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opacity, ")");
};

//rgbaColorString must be similar to "rgba(value, value, value, value)" 
//opacity should be between 0 and 1"
var changeColorOpacity = function changeColorOpacity(rgbaColorString, opacity) {
  var stringSplit = rgbaColorString.split(',');
  //assert length == 4
  stringSplit[3] = ' ' + opacity + ")";
  var newColorString = stringSplit.join();
  return newColorString;
};
export { PRIMARY, PRIMARY_HOVER, PRIMARY_SELECTED, SECONDARY, SECONDARY_HOVER, SECONDARY_SELECTED, STANDARD, STANDARD_LIGHT, STANDARD_HOVER, SECONDARY_LIGHT_HOVER, SECONDARY_LIGHT, BORDER, BORDER_HOVER, GRAYBG, GRAY_LIGHT, GRAY_LIGHTBG, GRAY_NONE, DIVIDER, ALTERNATIVE, INFORMATION, WARNING, ERROR, changeColorOpacity, fromHexaToRgba };